export default __webpack_public_path__ + "static/media/12.a63e2a72.png";